import SubscriptionApi from '../apis/subscription'
import CardApi from '../apis/card'
import UserApi from '../apis/user'

export const state = () => ({
  plan_id: "",
  stripe_key: "",
  token: "",
  plan_name: "",
  stripe_customer_id: '',
  host: "",
  plan_to_change: {},
  coupon_name: '',
  coupon_code: '',
  custom_plan_to_change: {},
  submitting_card: false,
  invoice_pending: false,
  current_plan_idx: 0,
  plans_arr: [],
  current_plan_id: 0,
  current_custom_plan_id: 0,
  hide_above_idx: 0,
  plan_names: ["free", "basic" ,"premium" ,"master" ,"enterprise", "1m_pv", "2m_pv"],
  is_anual: false,
  interval_count: 1,
  hide_change_label: false,
  plan_interval_name: "month"
});
export const actions = {
  async createSubscription({ commit, state }, stripe_token) {
    // 新規作成時もプラン変更できるように
    const {data} = await SubscriptionApi.create({
      stripe_token: stripe_token,
      plan_id: (state.plan_to_change)? state.plan_to_change.id : state.plan_id,
      coupon_code: state.coupon_code,
    })
    commit("setPlanName", data.plan_name)
    commit("setStripeCustomerId", data.stripe_customer_id)
  },
  async updateSubscription({ commit, state }) {
    const { data } = await SubscriptionApi.update({
      plan_id: state.plan_to_change.id,
      coupon_code: state.coupon_code,
    })
    commit("setPlanName", data.plan_name)
  },
  async destroySubscription({ commit, state }) {
    const { data } = await SubscriptionApi.destroy()
    commit("setPlanName", data.plan_name)
  },
  async pushCard({ commit, state }, source) {
    const {data} = await CardApi.create({
      source: source,
    })
  },
  async updateCard({ commit, state }, card_token) {
    const {data} = await CardApi.update({
      card_token: card_token,
    })
  },
  async removeCard({ commit, state }, card_token) {
    await CardApi.delete({
      card_token: card_token,
    })
  },
  async checkCouponExists({ commit, state }, coupon_code) {
    const {data} = await SubscriptionApi.check_coupon_exists({
      coupon_code: coupon_code,
      plan_id: state.plan_to_change.id ?? state.plan_id,
    })
    return data
  },
  updateCurrentPlanIdx({ commit, state }){
    let plans = []
    plans = state.plans_arr[state.plan_interval_name]
    plans.forEach((plan, idx)=>{
      if(state.plan_name == plan.name){
        commit("setCurrentPlanIdx", idx)
      }
    })
  },
  async acceptPolicy({ commit }, policy_version) {
    await UserApi.accept_policy(policy_version)
  },
  async saveUserInfo({ commit, state }, params) {
    await UserApi.save_user_info(params)
  },
  async saveServiceChange() {
    await UserApi.save_service_change()
  },
}
export const mutations = {
  setPlanId(state, plan_id){
    state.plan_id = plan_id
  },
  setStripeKey(state, stripe_key){
    state.stripe_key = stripe_key
  },
  setToken(state, token){
    state.token = token
  },
  setPlanName(state, plan_name){
    state.plan_name = plan_name
  },
  setCouponCode(state, coupon_code){
    state.coupon_code = coupon_code
  },
  setCouponName(state, coupon_name){
    state.coupon_name = coupon_name
  },
  setStripeCustomerId(state, stripe_customer_id){
    state.stripe_customer_id = stripe_customer_id
  },
  setHost(state, host){
    state.host = host
  },
  setPlanToChange(state, plan){
    state.plan_to_change = plan
  },
  setCustomPlanToChange(state, custom_plan){
    state.custom_plan_to_change = custom_plan
  },
  sethideChangeLabel(state, status){
    state.hide_change_label = status
  },
  onSubmittingCard(state){
    state.submitting_card = true
  },
  offSubmittingCard(state){
    state.submitting_card = false
  },
  setInvoicePending(state, invoice_pending){
    state.invoice_pending = invoice_pending
  },
  setCurrentPlanIdx(state, idx){
    state.current_plan_idx = idx
  },
  setPlansArr(state, arr){
    state.plans_arr = arr
  },
  unshiftPlansArr(state, hash){
    let plans = []
    for (let key in state.plans_arr) {
      state.plans_arr[key].unshift(hash)
    }
  },
  pushPlansArr(state, hash){
    let plans = []
    plans = state.plans_arr[state.plan_interval_name]
    plans.push(hash)
  },
  pushPlansArrForLp(state, hash){
    let plans = []
    plans = state.plans_arr
    plans.push(hash)
  },
  unshiftPlansArrForLp(state, hash){
    let plans = []
    plans = state.plans_arr
    plans.unshift(hash)
  },
  setCurrentPlanId(state, id){
    state.current_plan_id = id
  },
  setCurrentCustomPlanId(state, id){
    state.current_custom_plan_id = id
  },
  setHideAboveIdx(state, idx){
    state.hide_above_idx = idx
  },
  setIsAnual(state, bool){
    state.is_anual = bool
  },
  setIntervalCount(state, interval_count){
    state.interval_count = interval_count
  },
  setPlanIntervalName(state, interval_name){
    state.plan_interval_name = interval_name
  },
}
export const getters = {
  display_plans(state, getters){
    let plans = []
    plans = state.plans_arr[getters.plan_interval_name]
    if(state.hide_above_idx > 0){
      plans = plans.filter((plan, idx) => {
        return idx >= state.hide_above_idx
      })
    }
    return plans
  },
  plan_interval_name(state, getters){
    if(state.is_anual){
      return "year"
    } else {
      if(state.interval_count == 1){
        return "month"
      } else if (state.interval_count == 3){
        return "three_month"
      } else if (state.interval_count == 6){
        return "six_month"
      } else if (state.interval_count == 36){
        return "three_year"
      } else {
        return "month"
      }
    }
  },
  display_plans_for_lp(state, getters){
    let plans = []
    plans = state.plans_arr
    if(state.hide_above_idx > 0){
      plans = plans.filter((plan, idx) => {
        return idx >= state.hide_above_idx
      })
    }
    return plans
  },
  display_plans_reverse(state, getters){
    var plans = Object.assign({}, state.plans_arr);
  },
  is_upper_plan: (state) => (plan) => {
    var current_plan_idx , target_plan_idx
    state.plan_names.forEach((plan_name, idx) => {
      if(plan_name == state.plan_name){
        current_plan_idx = idx
      }
      if(plan_name == plan.name){
        target_plan_idx = idx
      }
    })
    return target_plan_idx > current_plan_idx
  },
  is_lower_plan: (state) => (plan) => {
    if(state.plan_name == "custom"){
      return true
    }
    var current_plan_idx, target_plan_idx
    state.plan_names.forEach((plan_name, idx) => {
      if(plan_name == state.plan_name){
        current_plan_idx = idx
      }
      if(plan_name == plan.name){
        target_plan_idx = idx
      }
    })
    return target_plan_idx < current_plan_idx
  },
  is_same_plan: (state) => (plan) => {
    return plan.name == state.plan_name
  },
  is_same_id: (state) => (plan) => {
    return plan.id == state.plan_id
  },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
